export class CompetitorCount {
  total?: number;
  withStartNumber?: number;
}
